export function CloseBlackIcon({ className }) {
  return (
    <svg
      width='54'
      height='54'
      viewBox='0 0 54 54'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g filter='url(#filter0_d_12730_28148)'>
        <rect x='4' y='2' width='46' height='46' rx='23' fill='black' fillOpacity='0.7' />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.6929 31.6917C34.1035 31.281 34.1035 30.6152 33.6929 30.2046L28.4879 24.9996L33.6917 19.7959C34.1023 19.3853 34.1023 18.7195 33.6917 18.3088C33.281 17.8982 32.6152 17.8982 32.2046 18.3088L27.0009 23.5126L21.7963 18.308C21.3856 17.8973 20.7198 17.8973 20.3092 18.308C19.8985 18.7186 19.8985 19.3844 20.3092 19.7951L25.5138 24.9996L20.308 30.2054C19.8973 30.6161 19.8973 31.2819 20.308 31.6925C20.7186 32.1032 21.3844 32.1032 21.7951 31.6925L27.0009 26.4867L32.2058 31.6917C32.6164 32.1023 33.2822 32.1023 33.6929 31.6917Z'
        fill='white'
      />
      <defs>
        <filter
          id='filter0_d_12730_28148'
          x='0'
          y='0'
          width='54'
          height='54'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_12730_28148' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_12730_28148' result='shape' />
        </filter>
      </defs>
    </svg>
  );
}
